<button mat-icon-button [matMenuTriggerFor]="menu" [class]="buttonStyle">
    <mat-icon [svgIcon]="icon" [class]="iconCustomClass"></mat-icon>
</button>
<mat-menu #menu="matMenu">
    <button *ngIf="isShow('show_group_id')" mat-menu-item (click)="onShowGroupID()">
        <mat-icon [svgIcon]="'heroicons_outline:clipboard-document'"></mat-icon>
        <span>{{'Show Group ID' | transloco}}</span>
    </button>
    <button *ngIf="isShow('edit_group') && canAccessGroup('edit-group')" mat-menu-item (click)="onEdit()">
        <mat-icon [svgIcon]="'heroicons_outline:pencil-square'"></mat-icon>
        <span>{{'Edit Group' | transloco}}</span>
    </button>
    <button *ngIf="isShow('leave_group') && !canAccessGroup('delete-group')" mat-menu-item
        (click)="onLeaveGroup('Leave')">
        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
        <span>{{'Leave Group' | transloco}}</span>
    </button>
    <button *ngIf="isShow('delete_group') && canAccessGroup('delete-group')" mat-menu-item
        (click)="onLeaveGroup('Delete')">
        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
        <span>{{'Delete Group' | transloco}}</span>
    </button>
    <button *ngIf="isShow('edit_device') && canAccessDevice('edit-device')" mat-menu-item (click)="buttonClick('edit_device')">
        <mat-icon [svgIcon]="'heroicons_outline:pencil-square'"></mat-icon>
        <span>{{'Edit Device' | transloco}}</span>
    </button>
    <button *ngIf="isShow('delete_device') && canAccessDevice('delete-device')" mat-menu-item
        (click)="onDeleteDevice()">
        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
        <span>{{'Delete Device' | transloco}}</span>
    </button>
    <button *ngIf="isShow('deactivate_rule')" mat-menu-item (click)="buttonClick('deactivate_rule')">
        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        <span>{{'Deactivate Rule' | transloco}}</span>
    </button>
    <button *ngIf="isShow('activate_rule')" mat-menu-item (click)="buttonClick('activate_rule')">
        <mat-icon [svgIcon]="'heroicons_outline:check'"></mat-icon>
        <span>{{'Activate Rule' | transloco}}</span>
    </button>
    <button *ngIf="isShow('edit_rule')" mat-menu-item (click)="buttonClick('edit_rule')">
        <mat-icon [svgIcon]="'heroicons_outline:pencil-square'"></mat-icon>
        <span>{{'Edit Rule' | transloco}}</span>
    </button>
    <button *ngIf="isShow('delete_rule')" mat-menu-item (click)="buttonClick('delete_rule')">
        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
        <span>{{'Delete Rule' | transloco}}</span>
    </button>
    <button *ngIf="isShow('edit_role')" mat-menu-item (click)="buttonClick('edit_role')">
        <mat-icon [svgIcon]="'heroicons_outline:pencil-square'"></mat-icon>
        <span>{{'Edit Role' | transloco}}</span>
    </button>
    <button *ngIf="isShow('remove_user')" mat-menu-item (click)="buttonClick('remove_user')">
        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
        <span>{{'Remove User' | transloco}}</span>
    </button>
    <button *ngIf="isShow('add_rule') && canAccessAlertRule('add-alert-rules')" mat-menu-item (click)="buttonClick('add_rule')">
        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        {{'Add Rule' | transloco}}
    </button>
    <button *ngIf="isShow('filter_rule')" mat-menu-item (click)="buttonClick('filter_rule')">
        <mat-icon [svgIcon]="'heroicons_outline:adjustments-horizontal'"></mat-icon>
        {{'Filter Rules' | transloco}}
    </button>
    <button *ngIf="isShow('add_device') && canAccessDevice('add-device')" mat-menu-item (click)="buttonClick('add_device')">
        <mat-icon [svgIcon]="'heroicons_outline:device-mobile'"></mat-icon>
        {{"Add Device"}}
    </button>
    <button *ngIf="isShow('filter_device')" mat-menu-item (click)="buttonClick('filter_device')">
        <mat-icon [svgIcon]="'heroicons_outline:adjustments-horizontal'"></mat-icon>
        {{'Filter Device' | transloco}}
    </button>
    <button *ngIf="isShow('invite_member') && canAccessMember('invite-members')" mat-menu-item (click)="buttonClick('invite_member')">
        <mat-icon [svgIcon]="'heroicons_outline:user-group'"></mat-icon>
        {{'Invite Member' | transloco}}
    </button>
    <button *ngIf="isShow('filter_member')" mat-menu-item (click)="buttonClick('filter_member')">
        <mat-icon [svgIcon]="'heroicons_outline:adjustments-horizontal'"></mat-icon>
        {{'Filter Member' | transloco}}
    </button>
</mat-menu>

@if(drawerOpen && isShow('edit_group') && canAccessGroup('edit-group')){
<app-drawer [opened]="drawerOpen" (cancel)="onCancel()" [title]="'Edit Group' | transloco"
    [image]="'/images/background/background.jpg'">
    <app-group-add-form (cancel)="onCancel()" [type]="'edit'" [data]="data"></app-group-add-form>
</app-drawer>
}